import { DEFAULT_DATA } from '../constants/common';

const initialState = {
  userZoneId: 'Europe/Minsk',
  defaultZoneId: 'Europe/Minsk',
  locale: 'ru-ru',
  fetching: false,
  actualizationDate: DEFAULT_DATA,
  amountCalculatedDate: DEFAULT_DATA,
  tenants: [],
  currency: '$',
};

const project = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER_ZONE_ID_SUCCESS':
      return {
        ...state,
        userZoneId: action.userZoneId,
      };

    case 'FETCH_PROJECT_OPTIONS':
      return {
        ...state,
        fetching: true,
      };

    case 'FETCH_PROJECT_OPTIONS_SUCCESS':
      return {
        ...state,
        fetching: false,
        ...action.options,
      };

    case 'FETCH_PROJECT_OPTIONS_FAILURE':
      return {
        ...state,
        fetching: false,
      };

    case 'FETCH_PROJECT_ACTUALIZATION_SUCCESS':
      return {
        ...state,
        actualizationDate: action.actualizationDate,
        amountCalculatedDate: action.amountCalculatedDate,
      };
    default:
      return state;
  }
};

export default project;

export const getOriginalZoneId = (state) => state.defaultZoneId;

export const getZoneId = (state) => state.userZoneId;

export const getLocale = (state) => state.locale;

export const areOptionsFetching = (state) => state.fetching;

export const getActualizationDate = (state) => state.actualizationDate;

export const getAmountCalculatedDate = (state) => state.amountCalculatedDate;

export const getProjectCurrency = (state) => state.currency;
